import App from "components/App/App";
import * as React from "react";
import ReactDOM from "react-dom/client";
import { Provider as ReduxStoreProvider } from "react-redux";
import { loadEnvironment } from "store/environment";
import { StoreService } from "store";
import { QueryClient, QueryClientProvider } from "react-query";
import { AppThemeProvider } from "#components/App/AppThemeProvider";
import { ReactQueryDevtools } from "react-query/devtools";
import { HistoryRouter } from "redux-first-history/rr6";
import { SnackbarProvider } from "notistack";

import { setUseWhatChange } from "@simbathesailor/use-what-changed";
import { createInstance, MatomoProvider } from "@iva/matomo-tracker-react";
// Only Once in your app you can set whether to enable hooks tracking or not.
// In CRA(create-react-app) e.g. this can be done in src/index.js

setUseWhatChange(process.env.NODE_ENV === "development");

export const queryClient = new QueryClient();

const storeService = new StoreService();

const matomoTrackerInstance = createInstance({
    urlBase: "https://websites.fraunhofer.de/fhg-igd-iva/",
    siteId: 3,
    // userId: 'UID76903202', // optional, default value: `undefined`.
    // trackerUrl: 'https://LINK.TO.DOMAIN/tracking.php', // optional, default value: `${urlBase}matomo.php`
    // srcUrl: 'https://LINK.TO.DOMAIN/tracking.js', // optional, default value: `${urlBase}matomo.js`
    // disabled: false, // optional, false by default. Makes all tracking calls no-ops if set to true.
    heartBeat: {
        // optional, enabled by default
        active: true, // optional, default value: true
        seconds: 10, // optional, default value: `15
    },
    // linkTracking: false, // optional, default value: true
    // configurations: { // optional, default value: {}
    //     // any valid matomo configuration, all below are optional
    //     disableCookies: true,
    //     setSecureCookie: true,
    //     setRequestMethod: 'POST'
    // }
});

const Root = () => (
    <QueryClientProvider client={queryClient}>
        <MatomoProvider value={matomoTrackerInstance}>
            <ReduxStoreProvider store={storeService.store}>
                <HistoryRouter history={storeService.history}>
                    <AppThemeProvider>
                        <SnackbarProvider maxSnack={3}>
                            <App />
                        </SnackbarProvider>
                    </AppThemeProvider>
                </HistoryRouter>
            </ReduxStoreProvider>
        </MatomoProvider>
        <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
);

// Entrypoint for react
const container = document.getElementById("app-main") as HTMLDivElement;
const root = ReactDOM.createRoot(container);
root.render(<Root />);
// Trigger loading of /env.json by manually dispatching the store action.
storeService.store.dispatch(loadEnvironment());
